import { defineMessages } from 'react-intl';

const messages = defineMessages({
  //overview
  Trainings: 'Trainings',
  TrainingsManagement: 'TrainingsManagement',
  Name: 'Name',
  Type: 'Type',
  Resource: 'Resource',
  Status: 'Status',
  ExpectedTrainingHours: 'Expected training hours',
  Hours: 'Hours',
  StartDate: 'Start date',
  EndDate: 'End date',
  Mandatory: 'Mandatory',
  Description: 'Description',
  NoDataFound: 'NoDataFound',
  Actions: 'Actions',
  Delete: 'Delete',
  DeleteTraining: 'Delete training',
  DeleteTrainingConfirmationMsg: 'Are you sure you want to delete this training?',
  EditTraining: 'Edit training',
  AddUsers: 'Add users',
  //add training
  What: 'What',
  AddTraining: 'Add training',
  TrainingCreated: 'Training created',
  CreateTraining: 'Create training',
  TrainingUpdated: 'Training updated',
  SearchPriceListItem: 'Search price list item',
  NoPriceListItemsFound: 'No price list items found',
  //trainingEmployees
  MarkAsComplete: 'Mark as complete',
  CancelEmployee: 'Cancel employee training',
  RegisterEmployee: 'Register employee',
  NoEmployeesRegistered: 'No employees registered yet',
  Teams: 'Teams',
  RegisteredTrainingHours: 'Registered training hours',
  NoTrainingsFound: 'No trainings found',
  Available: 'Registered Available',
  Completed: 'Completed',
  ReopenTrainingEmployee: 'Reopen training',
  PlanTrainingForSelectedEmployees: 'Plan training for selected employees',
  RegisteredHours: 'Registered hours',
  OwnCompany: 'Own company',
  SearchEmployees: 'Search employees',
  EmployeeType: 'Employee type',
  WithEmployeeTags: 'With employee tags',
  AllRoles: 'AllRoles',
  //trainingEmployeesOverview
  AddRegistration: 'Add registration',
  CompletedDate: 'Completed date',
  OpenTrainingDetails: 'Open training details',
  //filters
  ResetFilters: 'Reset filters',
  //EmployeeTraining
  Training: 'Training',
  Close: 'Close',
});

export default messages;
